import { MetalsTask } from "../models/metals-task.model";

export function scaleMetalsTasksToQuantity(tasks: MetalsTask[], qty: number) {
	const copy = structuredClone(tasks)
	const buildTaskTrees = () => {
		const taskIdToParentTasks: Record<string, MetalsTask[]> = {}
		for (const task of copy) {
			if (!taskIdToParentTasks[task.id]) {
				taskIdToParentTasks[task.id] = [];
			}

			if (!task.nextTaskId) continue;

			if (!taskIdToParentTasks[task.nextTaskId]) {
				taskIdToParentTasks[task.nextTaskId] = [];
			}

			taskIdToParentTasks[task.nextTaskId].push(task)
		}

		const endTasks = copy.filter(t => t.nextTaskId === null);

		return { endTasks, taskIdToParentTasks };
	}

	const walk = (task: MetalsTask, value: number, type: 'divide' | 'multiply') => {
		if (type === 'divide') {
			task.totalQuantity /= value;
		}
		if (type === 'multiply') {
			task.totalQuantity *= value
		}


		for (const parent of taskIdToParentTasks[task.id] ?? []) {
			walk(parent, value, type);
		}
	}
	const { endTasks, taskIdToParentTasks } = buildTaskTrees();


	for (const task of endTasks) {
		const divisor = Math.max(task.totalQuantity, 1);

		walk(task, divisor, 'divide')
	}

	const multiplier = qty;
	for (const task of endTasks) {
		walk(task, multiplier, 'multiply')
	}

	return copy.map(t => {
		t.completedQuantity = 0;
		t.totalQuantity = Math.ceil(t.totalQuantity);
		return t;
	})
}